<template>
  <iframe
    :src="hkVideoPlayerLink"
    width="100%"
    height="100%"
    id="ysOpenDevice"
    allowfullscreen>
  </iframe>
</template>

<script>
export default {
  name: "HKPlayer",
  props: {
    hkVideoPlayerLink: {
      type: String,
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HKPlayer/HKPlayer.vue